import { DeepPartial } from '@apollo/client/utilities'
import { ProcurementPurchaseRequestApprovableMetadataFragment } from 'generated/resources/graphql'

import MoneyWithCurrency from 'modules/core/lib/money'

export const getProcurementPurchaseRequestMetadata = (
  data: DeepPartial<ProcurementPurchaseRequestApprovableMetadataFragment>
) => {
  const locale = data.requesterEmployee?.access?.locale ?? 'en'

  const displayAmount = data.cost
    ? MoneyWithCurrency({
        amount: Number(data.cost.cents ?? 0),
        currency: data.cost.currency,
        locale,
      })
    : undefined

  const description = data.purchaseRequestDescription

  return [description, displayAmount].filter(Boolean)
}
